export default __webpack_public_path__ + "static/media/quote.93955974.jpg";